export default __webpack_public_path__ + "./images/sb.29ff1b84.svg";